import { MutableRefObject } from 'react';
import { Side, Align, HintPosition } from './hint.types';

const OFFSET = 8;
const ARROW_OFFSET = 0;

export const calcPosition = (
  rect: DOMRect,
  el: HTMLElement,
  side: Side,
  align: Align
): HintPosition => {
  const vw = window.innerWidth;
  const vh = window.innerHeight;
  const tw = el.offsetWidth;
  const th = el.offsetHeight;

  const centerH = (r: DOMRect) =>
    align === 'start'
      ? r.left
      : align === 'end'
      ? r.right - tw
      : r.left + r.width / 2 - tw / 2;
  const centerV = (r: DOMRect) =>
    align === 'start'
      ? r.top
      : align === 'end'
      ? r.bottom - th
      : r.top + r.height / 2 - th / 2;
  const arrowOffsetH = (r: DOMRect) =>
    align === 'start'
      ? ARROW_OFFSET
      : align === 'end'
      ? r.width - ARROW_OFFSET
      : r.width / 2;
  const arrowOffsetV = (r: DOMRect) =>
    align === 'start'
      ? ARROW_OFFSET
      : align === 'end'
      ? r.height - ARROW_OFFSET
      : r.height / 2;

  const pts: Record<Side, { top: number; left: number; arrowOffset: number }> =
    {
      top: {
        top: rect.top - th - OFFSET,
        left: centerH(rect),
        arrowOffset: arrowOffsetH(rect),
      },
      bottom: {
        top: rect.bottom + OFFSET,
        left: centerH(rect),
        arrowOffset: arrowOffsetH(rect),
      },
      left: {
        top: centerV(rect),
        left: rect.left - tw - OFFSET,
        arrowOffset: arrowOffsetV(rect),
      },
      right: {
        top: centerV(rect),
        left: rect.right + OFFSET,
        arrowOffset: arrowOffsetV(rect),
      },
    };

  const opp: Record<Side, Side> = {
    top: 'bottom',
    bottom: 'top',
    left: 'right',
    right: 'left',
  };

  for (const s of [
    side,
    opp[side],
    'top',
    'bottom',
    'left',
    'right',
  ] as Side[]) {
    const { top, left, arrowOffset } = pts[s];

    if (top >= 4 && left >= 4 && top + th <= vh - 4 && left + tw <= vw - 4) {
      return { top, left, actualSide: s, arrowOffset };
    }
  }

  return { ...pts[side], actualSide: side };
};

export const clearTimer = (
  ref: MutableRefObject<ReturnType<typeof setTimeout> | null>
) => {
  if (ref.current !== null) {
    clearTimeout(ref.current);
    ref.current = null;
  }
};
